import { withRouter } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ListView from './listView';


function ListingList(props) {

	if (false) {
		return (
			<div>
				<Card>
					<CardContent>You don't have permission to view any Subscription Providers at this time. Please contact your Systems Administrator for access.</CardContent>
				</Card>
			</div>
		)
	}

	return (
		<div className="w-full flex flex-col">
			<ListView />
		</div>
	);
}

export default withRouter(ListingList)
